/** Refinement marking products that are not to be listed on the PLP. */
export const HIDE_IN_PLP_REFINEMENT = 'c_hideInPLP';

/** Refinement marking products that are not to be listed in search results (quick search / search results page). */
export const EXCLUDE_FROM_SEARCH_REFINEMENT = 'c_excludeFromSearch';

/** Refinement used to classify products into configured search filter groups. */
export const FILTER_GROUP_REFINEMENT_ID = 'c_filterGroup';
